import { ChangeDetectionStrategy, Component } from '@angular/core';
import {Message} from "primeng/message";

@Component({
  selector: 'homey-error-message',
  imports: [
    Message
  ],
  templateUrl: './error-message.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ErrorMessageComponent {

}
